@if (viaBeschikbaar) {
    @if (heeftVia) {
        <div style="width: 75%">
            <snelstart-ui-alert type="info">
                Er zijn vooraf ingevulde gegevens beschikbaar vanuit de Belastingdienst. Deze gegevens zijn in te zien
                via het
                klantdossier. De gegevens kunnen worden ingelezen in de aangifte, maar dat hoeft niet. Klik hieronder op
                de button
                'Via {{ selectedYear }} inlezen'. Op dat moment worden automatisch
                de gegevens vanuit de VIA overgezet in de aangifte. Indien de aangifte afwijkende informatie bevat ten
                opzichte
                van de aangifte dan wordt de aangifte overschreven met de gegevens uit de VIA.
            </snelstart-ui-alert>
        </div>
    } @else {
        <div style="width: 75%">
            <snelstart-ui-alert type="warning">
                Er zijn (nog) geen vooraf ingevulde gegevens beschikbaar voor {{ selectedYear }}. Als er een
                actieve
                machtiging is voor de VIA {{ selectedYear }} ga dan naar de module Machtigingen
                in het klantdossier en kies daar bij VIA machtiging {{ selectedYear }} voor de optie Via Ophalen.
                Binnen 24
                uur zal de VIA hier beschikbaar zijn.
            </snelstart-ui-alert>
        </div>
    }
} @else {
    @if (this.selectedYear != this.actualYear) {
        <div style="width: 75%">
            <snelstart-ui-alert type="warning">
                Er zijn (nog) geen vooraf ingevulde gegevens beschikbaar voor {{ this.selectedYear }}. Als er een
                actieve
                machtiging is voor de VIA dan worden de gegevens automatisch door ons opgehaald op 1
                maart {{ this.selectedYear + 1 }}.<br/>
            </snelstart-ui-alert>
        </div>
    }
}

@if ((intermediaryEntity$ | async); as intermediary) {
    @if (intermediary.id === 1002848) {
        @if ((checkVorigJaar$ | async) && heeftVorigJaar) {
            <div style="width: 75%">
                @if (viaBeschikbaar) {
                    <snelstart-ui-alert type="warning">
                        Er is een aangifte inkomstenbelasting over {{ selectedYear - 1 }} beschikbaar. Deze aangifte kan
                        ingelezen worden als als basis voor de aangifte voor {{ selectedYear }}. Je kunt de gegevens na
                        inlezen naar wens aanpassen. Let wel op dat dit al ingevulde gegevens in de
                        aangifte {{ selectedYear }}overschrijft. Wel kan na het overnemen van de gegevens van vorig jaar
                        de VIA opnieuw worden ingelezen. Het inlezen van de VIA update alleen de aangifte.
                    </snelstart-ui-alert>
                } @else {
                    <snelstart-ui-alert type="warning">
                        Er is een aangifte inkomstenbelasting over {{ selectedYear - 1 }} beschikbaar. Deze aangifte kan
                        ingelezen worden als als basis voor de aangifte voor {{ selectedYear }}. Je kunt de gegevens na
                        inlezen naar wens aanpassen. Let wel op dat dit al ingevulde gegevens in de
                        aangifte {{ selectedYear }}overschrijft.
                    </snelstart-ui-alert>
                }
            </div>
        }
    }
}


<div class="col-auto pb-1">
    <snelstart-ui-button [config]="configUpdate"
                         [disabled]="!heeftVorigJaar"
                         class="pt-1 custom-input-225"
                         icon="arrow-up-from-dotted-line"
                         type="primary">
        Gegevens {{ selectedYear - 1 }} inlezen
    </snelstart-ui-button>
</div>

<div class="col-auto">
    <snelstart-ui-button [config]="configAangever"
                         [disabled]="!viaBeschikbaar || !heeftVia"
                         class="pt-1 custom-input-225"
                         icon="arrow-up-from-dotted-line"
                         type="primary">
        VIA {{ selectedYear }} aangever inlezen
    </snelstart-ui-button>
</div>

<div class="col-auto pt-1">
    <snelstart-ui-button [config]="configPartner"
                         [disabled]="!viaBeschikbaar || !heeftViaPartner"
                         class="pt-1 custom-input-225"
                         icon="arrow-up-from-dotted-line"
                         type="primary">
        VIA {{ selectedYear }} partner inlezen
    </snelstart-ui-button>
</div>
